module.exports = __webpack_public_path__ + "static/media/game_consoles1.aa81f393.png";